<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconBreakoutRooms_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M0 3.6A1.6 1.6 0 0 1 1.6 2h12.8A1.6 1.6 0 0 1 16 3.6v8.8a1.6 1.6 0 0 1-1.6 1.6H1.6A1.6 1.6 0 0 1 0 12.4zm2.4.8h4.8v3.2H2.4zm4.8 4H2.4v3.2h4.8zm1.6-4h4.8v3.2H8.8zm4.8 4H8.8v3.2h4.8z"
        clip-rule="evenodd"
    />
</svg>
